import { render, staticRenderFns } from "./SuperAdminLayout.vue?vue&type=template&id=3c506f78&"
import script from "./SuperAdminLayout.vue?vue&type=script&lang=js&"
export * from "./SuperAdminLayout.vue?vue&type=script&lang=js&"
import style0 from "./SuperAdminLayout.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports